import {
  BaseAmazonHandler,
  IAmazonRegionDefinition
} from '@portal/app/dashboard/integrations/shared/vendor-handlers/base-amazon-handler';
import { VendorIdSource } from '@portal/app/dashboard/integrations/shared/constants';

export class AmazonSellerHandler extends BaseAmazonHandler {
  private static readonly REGION_CONFIG: Record<string, IAmazonRegionDefinition> = {
    NA: {
      authUrl: 'https://sellercentral.amazon.com/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-na.amazon.com',
      label: 'North America (US, CA, MX, BR)'
    },
    EU: {
      authUrl: 'https://sellercentral-europe.amazon.com/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-eu.amazon.com',
      label: 'Europe (UK, DE, FR, IT, ES, +)'
    },
    FE: {
      authUrl: 'https://sellercentral.amazon.co.jp/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-fe.amazon.com',
      label: 'Far East (JP, AU, SG)'
    }
  };

  static getAvailableRegions() {
    return BaseAmazonHandler.buildAvailableRegions(
      AmazonSellerHandler.REGION_CONFIG
    );
  }

  protected getVendorId(): keyof typeof VendorIdSource {
    return 'amazon-seller';
  }

  protected getRegionConfig(): Record<string, IAmazonRegionDefinition> {
    return AmazonSellerHandler.REGION_CONFIG;
  }
}
